import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OutlinedText from "components/Input/OutlinedText/OutlinedText";
import s from "./CreateContent.module.scss";

const CreateContent = ({ handleInput }) => {
  const { t } = useTranslation();
  const [focus, setFocus] = useState({});

  const firstNameOnChange = (e) => {
    const { value } = e.target;
    handleInput(value, "firstName");
  };
  const firstNameOnFocus = () => {
    setFocus({ firstName: true });
  };
  const firstNameOnBlur = () => {
    setFocus({ firstName: false });
  };

  return (
    <div className={s.contentContainer}>
      <div>
        <OutlinedText
          label={t( "page.analytics.sales.performance.create.function.dialog.content.1")}
          noErrorMessage
          onchangeFn={firstNameOnChange}
          onfocusFn={firstNameOnFocus}
          onblurFn={firstNameOnBlur}
          sxParams={{ textFocus: focus.firstName }}
        />
      </div>
    </div>
  );
};

export default React.memo(CreateContent);
